import { useEffect, useState } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../contexts/AuthContext';

// Shared by every page that renders RichHtmlEditor (Signatures/Disclaimers/
// Campaigns) so the org's named brand colors can be offered as swatches in
// TinyMCE's color picker (see emailEditorConfig.js's color_map) without each
// page independently re-fetching the list on every mount.
export default function useOrganizationBrandColors() {
  const { user } = useAuth();
  const [colors, setColors] = useState([]);

  useEffect(() => {
    if (!user?.organization) return;
    // A local flag captured fresh by this effect run, NOT a ref — a
    // component-level ref would survive React 18 StrictMode's dev-only
    // double mount/unmount/mount of effects with its value still `false`
    // from the first (simulated) unmount, permanently blocking every future
    // setColors() call even though the component is genuinely still
    // mounted. This closure-local flag is reborn `false` on the second,
    // real run, same fix as the single-color hook this replaced.
    let cancelled = false;
    api.get(endpoints.signatures.brandColors.list)
      .then(data => { if (!cancelled) setColors(Array.isArray(data) ? data : []); })
      .catch(() => { if (!cancelled) setColors([]); });
    return () => { cancelled = true; };
  }, [user?.organization]);

  return [colors];
}
